import { RuleModule } from 'utils/i18n/TModules';

// Translation Keys and Paths
export const RuleListPageKey = `RuleListPage`;
export const TRuleListPage = `${RuleModule}:${RuleListPageKey}`;

export const RuleCreatePageKey = `RuleCreatePage`;
export const TRuleCreatePage = `${RuleModule}:${RuleCreatePageKey}`;
